<div
  class="cv-page cv10"
  [ngClass]="{ 'thumbnail-view': isThumbnail }"
>
  <div class="cv-frame">
    <!-- LEFT COLUMN -->
    <aside class="left-col">
      <!-- NAME / TITLE -->
      <div class="name-block">
        <div class="first-name">{{ data.firstName }}</div>
        <div class="last-name">{{ data.lastName }}</div>
        <div
          class="designation"
          *ngIf="data.designation"
        >
          {{ data.designation }}
        </div>
      </div>

      <!-- CONTACT -->
      <section
        class="side-section contact"
        *ngIf="data.contactDetails"
      >
        <h3 class="section-heading">
          <span
            class="heading-icon"
            aria-hidden="true"
          >
            <!-- user icon -->
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 12C14.2091 12 16 10.2091 16 8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8C8 10.2091 9.79086 12 12 12Z"
                fill="white"
              />
              <path
                d="M4 20C4 16.6863 7.58172 14 12 14C16.4183 14 20 16.6863 20 20"
                fill="white"
              />
            </svg>
          </span>
          CONTACT
        </h3>

        <ul class="contact-list">
          <li *ngIf="data.contactDetails?.email">
            <span class="item-icon"
              ><svg
                viewBox="0 0 24 24"
                width="20"
                height="20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <!-- Square background with rounded corners -->
                <rect
                  x="2"
                  y="2"
                  width="20"
                  height="20"
                  rx="4"
                  fill="#f6bdae"
                />

                <!-- White envelope icon -->
                <path
                  d="M4 7h16v10H4z"
                  fill="none"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linejoin="round"
                />
                <path
                  d="M4 7l8 6 8-6"
                  fill="none"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
            <span class="item-text">{{ data.contactDetails.email }}</span>
          </li>

          <li *ngIf="data.contactDetails?.number">
            <span class="item-icon"
              ><svg
                viewBox="0 0 24 24"
                width="12"
                height="12"
                fill="white"
              >
                <path
                  d="M6.6 10.8a12.1 12.1 0 0 0 6.6 6.6l1.8-1.8a1 1 0 0 1 1-.2c1.2.5 2.6.8 4 .8a1 1 0 0 1 1 1v2.2a1 1 0 0 1-1 1C8.1 22 2 15.9 2 7a1 1 0 0 1 1-1h2.2a1 1 0 0 1 1 1c0 1.4.3 2.8.8 4a1 1 0 0 1-.2 1l-1.8 1.8z"
                  fill="white"
                /></svg
            ></span>
            <span class="item-text">{{ data.contactDetails.number }}</span>
          </li>

          <li *ngIf="data.contactDetails?.address">
            <span class="item-icon"
              ><svg
                viewBox="0 0 24 24"
                width="12"
                height="12"
                fill="white"
              >
                <path
                  d="M12 2C8 2 5 5 5 9c0 5.3 7 13 7 13s7-7.7 7-13c0-4-3-7-7-7z"
                  fill="white"
                />
                <circle
                  cx="12"
                  cy="9"
                  r="2.2"
                  fill="#fff"
                /></svg
            ></span>
            <span class="item-text">{{
              data.contactDetails.address || data?.city
            }}</span>
          </li>

          <li *ngIf="data.contactDetails?.linkedIn">
            <span class="item-icon"
              ><svg
                viewBox="0 0 24 24"
                width="12"
                height="12"
                fill="white"
              >
                <path
                  d="M4.98 3.5C4.98 4.6 4.14 5.5 3 5.5S1 4.6 1 3.5 1.84 1.5 3 1.5s1.98.9 1.98 2zM.5 8h5V23h-5zM8 8h4.78v2.07h.07c.66-1.25 2.28-2.57 4.69-2.57C22 7.5 23 11 23 14.77V23h-5v-7.84c0-1.87-.03-4.27-2.6-4.27-2.6 0-3 2.03-3 4.14V23H8V8z"
                  fill="white"
                /></svg
            ></span>
            <span class="item-text">{{ data.contactDetails.linkedIn }}</span>
          </li>
        </ul>
      </section>

      <!-- EDUCATION -->
      <section
        class="side-section education"
        *ngIf="data.educations?.length"
      >
        <h3 class="section-heading">
          <span class="heading-icon">
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M12 2L1 7l11 5 9-4.09V17h2V7L12 2z"
                fill="white"
              />
            </svg>
          </span>
          EDUCATION
        </h3>

        <div class="edu-list">
          <div
            class="edu-item"
            *ngFor="let edu of data.educations"
          >
            <div class="degree">{{ edu.courseName }}</div>
            <div class="school">{{ edu.universityName }}</div>
            <div class="edu-meta">
              {{ edu.formattedDate }}
              <span *ngIf="edu.location"> | {{ edu.location }}</span>
            </div>
          </div>
        </div>
      </section>

      <!-- SKILLS -->
      <section
        class="side-section skills"
        *ngIf="data.skills?.length"
      >
        <h3 class="section-heading">
          <span class="heading-icon">
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M12 2l3 7h7l-5.5 4 2 7L12 17l-6.5 3 2-7L2 9h7l3-7z"
                fill="white"
              />
            </svg>
          </span>
          SKILLS
        </h3>
        <ul class="skills-list">
          <li *ngFor="let s of data.skills">{{ s }}</li>
        </ul>
      </section>

      <!-- CERTIFICATIONS -->
      <section
        class="side-section certs"
        *ngIf="data.certifications?.length"
      >
        <h3 class="section-heading">
          <span class="heading-icon">
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M12 2l3 7h7l-5.5 4 2 7L12 17l-6.5 3 2-7L2 9h7l3-7z"
                fill="white"
              />
            </svg>
          </span>
          CERTIFICATIONS
        </h3>
        <ul class="cert-list">
          <li *ngFor="let c of data.certifications">
            <strong *ngIf="c.name">{{ c.name }}</strong
            ><span *ngIf="c.authority"> — {{ c.authority }}</span>
            <div
              class="cert-date"
              *ngIf="c.date"
            >
              {{ c.date }}
            </div>
          </li>
        </ul>
      </section>
    </aside>

    <!-- RIGHT COLUMN: EXPERIENCE -->
    <main class="right-col">
      <section class="experience">
        <h3 class="exp-heading">
          <span class="exp-icon">
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M12 2L1 7l11 5 9-4.09V17h2V7L12 2z"
                fill="#f6bdae"
              />
            </svg>
          </span>
          WORK EXPERIENCE
        </h3>

        <div
          class="exp-item"
          *ngFor="let exp of data.experience"
        >
          <h4 class="job-title">{{ exp.Title }}</h4>

          <!-- <div class="company-line">
            <span class="company">{{ exp.company }}</span>
          </div> -->

          <div class="meta-line">
            <span class="meta-item">
              <svg
                class="meta-icon"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <!-- Orange background square with rounded corners -->
                <rect
                  x="2"
                  y="2"
                  width="20"
                  height="20"
                  rx="4"
                  fill="#f6bdae"
                />

                <!-- White calendar icon -->
                <rect
                  x="6"
                  y="8"
                  width="12"
                  height="10"
                  rx="2"
                  ry="2"
                  fill="none"
                  stroke="white"
                  stroke-width="2"
                />
                <path
                  d="M6 11h12"
                  stroke="white"
                  stroke-width="2"
                />
                <path
                  d="M9 6v4"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <path
                  d="M15 6v4"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                />
              </svg>

              <span class="dates"
                >{{ exp.startDate }} - {{ exp.endDate || 'Present' }}</span
              >
            </span>

            <span
              class="meta-item"
              *ngIf="exp.joblocation.City || exp.joblocation.State"
            >
              <svg
                class="meta-icon"
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M12 2C8 2 5 5 5 9c0 5.3 7 13 7 13s7-7.7 7-13c0-4-3-7-7-7z"
                  fill="#f6bdae"
                />
                <circle
                  cx="12"
                  cy="9"
                  r="2.2"
                  fill="#fff"
                />
              </svg>
              <span class="location">
                {{ exp.joblocation?.City
                }}{{
                  exp.joblocation?.State ? ', ' + exp.joblocation.State : ''
                }}
              </span>
            </span>
          </div>

          <ul class="exp-bullets">
            <li *ngFor="let pt of exp.descriptionPoints">{{ pt }}</li>
          </ul>
        </div>
      </section>
    </main>
  </div>
</div>
